import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Columna 1: Información */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '1px' }}>
              STRATEGOS OVERLAND
            </h3>
            <p className="text-sm text-gray-400">
              Experiencias de mototurismo inolvidables
            </p>
          </div>

          {/* Columna 2: Enlaces Legales */}
          <div>
            <h4 className="text-white font-semibold mb-4">Información Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/aviso-legal" className="hover:text-orange-500 transition-colors">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link to="/condiciones-de-uso" className="hover:text-orange-500 transition-colors">
                  Condiciones de Uso
                </Link>
              </li>
              <li>
                <Link to="/privacidad-y-cookies" className="hover:text-orange-500 transition-colors">
                  Privacidad y Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3: Contacto */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contacto</h4>
            <p className="text-sm text-gray-400 mb-3">
              by Javi Garmendia
            </p>
            <a 
              href="mailto:info@sttgs-overland.com" 
              className="text-sm text-orange-500 hover:text-orange-400 transition-colors flex items-center gap-2"
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-4 w-4" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                />
              </svg>
              info@sttgs-overland.com
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Strategos Overland. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
